/**
 * Entrega um arquivo ao navegador (§7.5).
 *
 * Um `<a download>` com URL de objeto, e não `toDataURL`: um tabuleiro grande
 * vira uma string de vários megabytes, e alguns navegadores recusam um `href`
 * desse tamanho.
 */
export function baixarArquivo(blob: Blob, nome: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nome;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  // O objeto só pode ser liberado depois de o navegador ter começado a baixar;
  // revogar na mesma volta do laço cancela o download no WebKit.
  window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

/** Nome do arquivo: previsível, ordenável e sem acento. */
export function nomeDoArquivo(dia: string | undefined, extensao: 'png' | 'gif'): string {
  const carimbo = dia ?? new Date().toISOString().slice(0, 10);
  return `entreletras-${carimbo}.${extensao}`;
}
